/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class VmAgentsQueryOsTypes extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("VmAgentsQueryOsTypes");
    }

    getFixupPrototypeFunction() { return VmAgentsQueryOsTypes.fixupPrototype; }

    static newInstance(model: Partial<VmAgentsQueryOsTypes>): VmAgentsQueryOsTypes {
        let obj = Object.assign(new VmAgentsQueryOsTypes(), model);
        VmAgentsQueryOsTypes.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<VmAgentsQueryOsTypes>): VmAgentsQueryOsTypes {
        if (!model) return null;
        return VmAgentsQueryOsTypes.newInstance(<VmAgentsQueryOsTypes> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: VmAgentsQueryOsTypes) {
        if (!obj) return;

        models.VmAgentsQueryOsTypes.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: VmAgentsQueryOsTypes): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, VmAgentsQueryOsTypes.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Types of OS
     */
    os_type: Array<models.OsTypes>;

}
